import { useAuth } from '../auth/AuthProvider'
import { SupplierCatalogPage } from '../components/SupplierCatalogPage'
import { useBuyerEntitlements } from '../hooks/useBuyerEntitlements'

export const RestaurantMyPricesScreen = () => {
  const { session } = useAuth()
  const entitlements = useBuyerEntitlements()
  if (!session) {
    return null
  }

  const supplierLimitLabel =
    entitlements.maxPrivateSuppliers != null
      ? `${entitlements.privateSuppliersUsed ?? 0} / ${entitlements.maxPrivateSuppliers}`
      : null

  const billingNote = supplierLimitLabel
    ? `Поставщиков в «Моих прайсах»: ${supplierLimitLabel}${
        entitlements.privateSupplierRefreshDays
          ? ` · обновление прайса — не чаще 1 раза в ${entitlements.privateSupplierRefreshDays} дн. на «Старте»`
          : ''
      }`
    : null

  return (
    <SupplierCatalogPage
      organizationId={session.organizationId}
      importPath="/my-prices/import"
      catalogMode="restaurant-my-prices"
      title="Мои прайсы"
      billingNote={billingNote}
    />
  )
}
